import React, { useState, useCallback } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { SbSpin } from "uiCore";
import SbModal from "uiCore/SbModal/SbModal";
import { PreviewScrollStyled } from "./PdfPreviewModal.styles";

// pdf.js renders PDFs to a canvas and does NOT execute embedded PDF JavaScript,
// so a malicious uploaded PDF is displayed safely (no XSS / no app.alert).
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

// Extra hardening: disable eval-based rendering paths in pdf.js.
const PDF_OPTIONS = { isEvalSupported: false };
const PAGE_WIDTH = 820;

/**
 * Safe inline PDF preview for untrusted uploaded files.
 * Renders each page to canvas via pdf.js — never runs the PDF's scripts.
 */
const PdfPreviewModal = ({ file, open, onClose, title = "Preview" }) => {
  const [numPages, setNumPages] = useState(0);
  const [error, setError] = useState(null);

  const onLoadSuccess = useCallback(({ numPages }) => {
    setNumPages(numPages);
    setError(null);
  }, []);

  const onLoadError = useCallback(() => {
    setError("Could not render this file for preview.");
  }, []);

  return (
    <SbModal open={open} onCancel={onClose} footer={null} width={900} title={title} destroyOnHidden>
      <PreviewScrollStyled>
        {error ? (
          <p>{error}</p>
        ) : (
          file && (
            <Document
              file={file}
              options={PDF_OPTIONS}
              onLoadSuccess={onLoadSuccess}
              onLoadError={onLoadError}
              loading={<SbSpin />}
            >
              {Array.from({ length: numPages }, (_, i) => (
                <Page
                  key={`page_${i + 1}`}
                  pageNumber={i + 1}
                  width={PAGE_WIDTH}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              ))}
            </Document>
          )
        )}
      </PreviewScrollStyled>
    </SbModal>
  );
};

export default PdfPreviewModal;
